import { createContext, useContext, useEffect, useState } from "react"
import axios from "axios"

/* ✅ Keep default export for old code */
const AuthContext = createContext({
  user: null,
  setUser: () => {},
})

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined) // undefined = loading

  const refreshUser = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/me`, {
        withCredentials: true,
      })

      setUser(data)
    } catch {
      setUser(null)
    }
  }

  useEffect(() => {
    refreshUser()
  }, [])

  return (
    <AuthContext.Provider value={{ user, setUser, refreshUser }}>
      {children}
    </AuthContext.Provider>
  )
}

/* ✅ New hook (preferred) */
export const useAuth = () => useContext(AuthContext)

/* ✅ OLD default export still works */
export default AuthContext
